import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** The column definition for the member's projects table with the field property typed */
export type MemberProjectsTableGridColDef = DataGridCellParams<
  FaroCoreApiTypes.AdmMembersProjects,
  MemberProjectsTableColumnField
>;

/** The column fields that can be used in the member's projects table */
export type MemberProjectsTableColumnField =
  "name" | "id" | "role" | "archived" | "createdAt" | "modifiedAt" | "options";

/** The labels for the columns in the member's projects table */
export const MEMBER_PROJECTS_TABLE_COLUMN_LABELS: Record<
  MemberProjectsTableColumnField,
  string
> = {
  name: "Project Name",
  id: "Project Id",
  role: "Role",
  archived: "Archiving State",
  createdAt: "Created At",
  modifiedAt: "Modified At",
  options: "",
};
